import React from 'react';
import { Modal, Button, Row, Col, Card } from 'react-bootstrap';
import '../stylesheets/ModalOp.css';
import { getTerminalDetail } from '../services/transactionService';
import TerminalInfoList from './TerminalInfoList';
class TerminalInfoModal extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            terminals: localStorage.terminals ? JSON.parse(localStorage.getItem('terminals')) : '',
            selectedTerminal: localStorage.frequentTerminal ? localStorage.getItem('frequentTerminal') : '',
            TerminalDetail: '',
            showSpinner: true
        };

        this.handleChange = this.handleChange.bind(this);
        this.noOfTerminals = JSON.parse(localStorage.getItem('terminals')).length;
    }

    componentDidMount() {
        this.getDetail(this.state.selectedTerminal);
    }

    getDetail = (TerminalId) => {
        getTerminalDetail(TerminalId).then(result => {
            if (result.status === 200) {
                this.setState({ TerminalDetail: result.data, showSpinner: false });
            } else {
                if (result.response.data.error === 'unauthorized request') {
                    this.handleClose();
                    this.props.showErrorModal('Timeout');
                } else {
                    this.setState({ TerminalDetail: result.response.data, showSpinner: false });
                }
            }
        }
        );
    }

    handleChange(event) {
        this.setState({ selectedTerminal: event.target.value });
        this.getDetail(event.target.value);
    }

    handleClose = () => this.props.closeModal();
    render() {
        return (
            <Modal show={this.props.show} backdrop="static" onHide={this.handleClose} animation={false}>
                <div id="printme">
                    <Modal.Header>
                        <Modal.Title>{this.props.translatedContent.TerminalDetailTitle}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Row>
                            <Col>
                                <label htmlFor="selectTerminalForDetail">
                                    <Card.Title>
                                        {this.noOfTerminals === 1 ?
                                            this.props.translatedContent.TerminalId
                                            :
                                            this.props.translatedContent.SelTerminalId
                                        }
                                    </Card.Title>
                                </label>
                            </Col>
                            <Col>
                                {
                                    this.noOfTerminals === 1 ?
                                        <div className="custom-select no-backG" id="selectTerminal">{this.state.terminals[0]}</div>
                                        :
                                        <select className="custom-select" value={this.state.selectedTerminal} id="selectTerminal" selected={this.state.selectedTerminal} onChange={this.handleChange}>
                                            {
                                                this.state.terminals !== '' ?
                                                    this.state.terminals.map((list, key) => {
                                                        return <option key={key} value={list}>{list}</option>;
                                                    })
                                                    :
                                                    ''
                                            }
                                        </select>
                                }
                            </Col>
                        </Row>
                        <TerminalInfoList data={this.state.TerminalDetail} translation={this.props.translatedContent} showSpinner={this.state.showSpinner} />
                    </Modal.Body>
                </div>
                <Modal.Footer>
                    <Button variant="secondary" id="closeTransactionDialogue" onClick={this.handleClose}>
                        {this.props.buttonText.Close}
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }
}
export default TerminalInfoModal;